export class ExecutorEarningsReport {
  executor_earnings_sum: number = 0;
}
